(function ($, Cobalt, undefined) {
    Cobalt.Markup = {
        customBBcodeButtons: [],
        dependentScripts: function () {
            return [{ dependency: Cobalt.User, name: "Cobalt.User" }];
        },
        initialize: function () {
            var miu = {
                markdownTitle: function (markItUp, character) {
                    var heading = '';
                    var n = $.trim(markItUp.selection || markItUp.placeHolder).length;
                    for (var i = 0; i < n; i++) {
                        heading += character;
                    }
                    return '\n' + heading;
                }
            };

            $("body").on("click", ".markItUpButton-smiley", function (e) {
                e.preventDefault();
                Cobalt.Smilies.showModal();
            });
            $("body").on("click", ".markItUpButton-dice", function (e) {
                e.preventDefault();
                Cobalt.Dice.showModal();
            });

            Cobalt.Markup.markItUpSets = {
                base: {
                    resizeHandle: true
                },
                creole: {
                    nameSpace: 'markItUp-creole',
                    onShiftEnter: { keepDefault: false, replaceWith: '\n\n' },
                    previewParserPath: "/markup-preview/creole",
                    markupSet: [
                            { name: 'Heading 1', key: '1', openWith: '= ', closeWith: ' =', placeHolder: 'Your title here...', className: "markItUpButton-heading-1" },
                            { name: 'Heading 2', key: '2', openWith: '== ', closeWith: ' ==', placeHolder: 'Your title here...', className: "markItUpButton-heading-2" },
                            { name: 'Heading 3', key: '3', openWith: '=== ', closeWith: ' ===', placeHolder: 'Your title here...', className: "markItUpButton-heading-3" },
                            { name: 'Heading 4', key: '4', openWith: '==== ', closeWith: ' ====', placeHolder: 'Your title here...', className: "markItUpButton-heading-4" },
                            { name: 'Heading 5', key: '5', openWith: '===== ', closeWith: ' =====', placeHolder: 'Your title here...', className: "markItUpButton-heading-5" },
                            { separator: '---------------' },
                            { name: 'Bold', key: 'B', openWith: "**", closeWith: "**", className: "markItUpButton-bold" },
                            { name: 'Italic', key: 'I', openWith: "//", closeWith: "//", className: "markItUpButton-italic" },
                            { separator: '---------------' },
                            { name: 'Bulleted list', openWith: '(!(* |!|*)!)', className: "markItUpButton-list-bullet" },
                            { name: 'Numeric list', openWith: '(!(# |!|#)!)', className: "markItUpButton-list-numeric" },
                            { separator: '---------------' },
                            { name: 'Picture', key: "P", replaceWith: '{{[![Url:!:http://]!]|[![name]!]}}', className: "markItUpButton-insert-image" },
                            { name: 'Link', key: "L", openWith: "[[[![Link]!]|", closeWith: ']]', placeHolder: 'Your text to link here...', className: "markItUpButton-insert-link" },
                    ]
                },
                bbcode: {
                    nameSpace: 'markItUp-bbcode',
                    onShiftEnter: { keepDefault: false, replaceWith: '\n\n' },
                    previewParserPath: "/markup-preview/bbcode",
                    markupSet: [
                        { name: 'Bold', key: 'B', openWith: "[b]", closeWith: "[/b]", className: "markItUpButton-bold" },
                        { name: 'Italic', key: 'I', openWith: "[i]", closeWith: "[/i]", className: "markItUpButton-italic" },
                        { name: 'Underline', key: 'U', openWith: '[u]', closeWith: '[/u]', className: "markItUpButton-underline" },
                        { name: 'Strikethrough', key: 'S', openWith: '[s]', closeWith: '[/s]', className: "markItUpButton-strikethrough" },
                        { separator: '---------------' },
                        { name: 'List Item', openWith: '[*]', closeWith: '\n', className: 'markItUpButton-list-item' },
                        { name: 'Bulleted list', openWith: '[list]\n[*]', closeWith: '\n[/list]', className: "markItUpButton-list-bullet" },
                        { name: 'Numeric list', openWith: '[numlist]\n[*]', closeWith: '\n[/numlist]', className: "markItUpButton-list-numeric" },
                        { separator: '---------------' },
                        { name: 'Picture', key: "P", replaceWith: '[img][![Url:!:http://]!][/img]', className: "markItUpButton-insert-image" },
                        { name: 'Link', openWith: "[url=[![Url:!:http://]!]]", closeWith: '[/url]', className: "markItUpButton-insert-link" },
                        { name: 'Embed a video', openWith: "[youtube][![Url:!:http://]!]", closeWith: '[/youtube]', className: "markItUpButton-insert-video" },
                    ]
                },
                standardbbcode: {
                    nameSpace: 'markItUp-bbcode',
                    onShiftEnter: { keepDefault: false, replaceWith: '\n\n' },
                    previewParserPath: "/markup-preview/bbcode",
                    markupSet: [
                        { name: 'Bold', key: 'B', openWith: "[b]", closeWith: "[/b]", className: "markItUpButton-bold" },
                        { name: 'Italic', key: 'I', openWith: "[i]", closeWith: "[/i]", className: "markItUpButton-italic" },
                        { name: 'Underline', key: 'U', openWith: '[u]', closeWith: '[/u]', className: "markItUpButton-underline" },
                        { name: 'Strikethrough', key: 'S', openWith: '[s]', closeWith: '[/s]', className: "markItUpButton-strikethrough" },
                        { separator: '---------------' },
                        { name: 'Bulleted list', className: "markItUpButton-list-bullet" },
                        { name: 'Numeric list', className: "markItUpButton-list-numeric" },
                        { name: 'List Item', openWith: '[*]', closeWith: '\n', className: 'markItUpButton-list-item' },
                        { separator: '---------------' },
                        { name: 'Picture', key: "P", replaceWith: '[img][![Url:!:http://]!][/img]', className: "markItUpButton-insert-image" },
                        { name: 'Link', openWith: "[url=[![Url:!:http://]!]]", closeWith: '[/url]', className: "markItUpButton-insert-link" },
                        { name: 'Size', openWith: '[size=[![Text size]!]]', closeWith: '[/size]', className: "markItUpButton-font-size" },
                        { name: 'Colors', openWith: '[color=[![Color]!]]', closeWith: '[/color]', className: "markItUpButton-color" },
                        { separator: '---------------' },
                        { name: 'Left', openWith: "[left]", closeWith: "[/left]", className: "markItUpButton-left" },
                        { name: 'Center', openWith: "[center]", closeWith: "[/center]", className: "markItUpButton-center" },
                        { name: 'Right', openWith: "[right]", closeWith: "[/right]", className: "markItUpButton-right" },
                        { separator: '---------------' },
                        { name: 'Spoiler', openWith: '[spoiler=[![Label]!]]', closeWith: '[/spoiler]', className: "markItUpButton-spoiler" },
                        { name: 'Quote', openWith: '[quote]', closeWith: '[/quote]', className: "markItUpButton-quote" },
                        { name: 'Smiley', className: "markItUpButton-smiley" },
                        { separator: '---------------' },
                        { name: 'Dice', className: "markItUpButton-dice" }
                    ]
                },
                rawhtml: {
                    nameSpace: 'markItUp-rawhtml',
                    previewParserPath: "/markup-preview/rawhtml",
                    onShiftEnter: { keepDefault: false, replaceWith: '<br />\n' },
                    onCtrlEnter: { keepDefault: false, openWith: '\n<p>', closeWith: '</p>\n' },
                    onTab: { keepDefault: false, openWith: '	 ' },
                    markupSet: [
                            { name: 'Heading 1', key: '1', openWith: '<h1(!( class="[![Class]!]")!)>', closeWith: '</h1>', placeHolder: 'Your title here...', className: "markItUpButton-heading-1" },
                            { name: 'Heading 2', key: '2', openWith: '<h2(!( class="[![Class]!]")!)>', closeWith: '</h2>', placeHolder: 'Your title here...', className: "markItUpButton-heading-2" },
                            { name: 'Heading 3', key: '3', openWith: '<h3(!( class="[![Class]!]")!)>', closeWith: '</h3>', placeHolder: 'Your title here...', className: "markItUpButton-heading-3" },
                            { name: 'Heading 4', key: '4', openWith: '<h4(!( class="[![Class]!]")!)>', closeWith: '</h4>', placeHolder: 'Your title here...', className: "markItUpButton-heading-4" },
                            { name: 'Heading 5', key: '5', openWith: '<h5(!( class="[![Class]!]")!)>', closeWith: '</h5>', placeHolder: 'Your title here...', className: "markItUpButton-heading-5" },
                            { name: 'Heading 6', key: '6', openWith: '<h6(!( class="[![Class]!]")!)>', closeWith: '</h6>', placeHolder: 'Your title here...', className: "markItUpButton-heading-6" },
                            { name: 'Paragraph', openWith: '<p(!( class="[![Class]!]")!)>', closeWith: '</p>' },
                            { separator: '---------------' },
                            { name: 'Bold', key: 'B', openWith: '(!(<strong>|!|<b>)!)', closeWith: '(!(</strong>|!|</b>)!)', className: "markItUpButton-bold" },
                            { name: 'Italic', key: 'I', openWith: '(!(<em>|!|<i>)!)', closeWith: '(!(</em>|!|</i>)!)', className: "markItUpButton-italic" },
                            { name: 'Stroke through', key: 'S', openWith: '<del>', closeWith: '</del>', className: "markItUpButton-strikethrough" },
                            { separator: '---------------' },
                            { name: 'Ul', openWith: '<ul>\n', closeWith: '</ul>\n', className: "markItUpButton-list-bullet" },
                            { name: 'Ol', openWith: '<ol>\n', closeWith: '</ol>\n', className: "markItUpButton-list-numeric" },
                            { name: 'Li', openWith: '<li>', closeWith: '</li>' },
                            { separator: '---------------' },
                            { name: 'Picture', key: 'P', replaceWith: '<img src="[![Source:!:http://]!]" alt="[![Alternative text]!]" />', className: "markItUpButton-insert-image" },
                            { name: 'Link', key: 'L', openWith: '<a href="[![Link:!:http://]!]"(!( title="[![Title]!]")!)>', closeWith: '</a>', placeHolder: 'Your text to link...', className: "markItUpButton-insert-link" },
                    ]
                },
                markdown: {
                    onShiftEnter: { keepDefault: false, openWith: '\n\n' },
                    markupSet: [
                            { name: 'Heading 1', key: '1', placeHolder: 'Your title here...', closeWith: function (markItUp) { return miu.markdownTitle(markItUp, '=') }, className: "markItUpButton-heading-1" },
                            { name: 'Heading 2', key: '2', placeHolder: 'Your title here...', closeWith: function (markItUp) { return miu.markdownTitle(markItUp, '-') }, className: "markItUpButton-heading-2" },
                            { name: 'Heading 3', key: '3', openWith: '### ', placeHolder: 'Your title here...', className: "markItUpButton-heading-3" },
                            { name: 'Heading 4', key: '4', openWith: '#### ', placeHolder: 'Your title here...', className: "markItUpButton-heading-4" },
                            { name: 'Heading 5', key: '5', openWith: '##### ', placeHolder: 'Your title here...', className: "markItUpButton-heading-5" },
                            { name: 'Heading 6', key: '6', openWith: '###### ', placeHolder: 'Your title here...', className: "markItUpButton-heading-6" },
                            { separator: '---------------' },
                            { name: 'Bold', key: 'B', openWith: '**', closeWith: '**', className: "markItUpButton-bold" },
                            { name: 'Italic', key: 'I', openWith: '_', closeWith: '_', className: "markItUpButton-italic" },
                            { separator: '---------------' },
                            { name: 'Bulleted List', openWith: '- ', className: "markItUpButton-list-bullet" },
                            {
                                name: 'Numeric List', openWith: function (markItUp) {
                                    return markItUp.line + '. ';
                                }, className: "markItUpButton-list-numeric"
                            },
                            { separator: '---------------' },
                            { name: 'Picture', key: 'P', replaceWith: '![[![Alternative text]!]]([![Url:!:http://]!] "[![Title]!]")', className: "markItUpButton-insert-image" },
                            { name: 'Link', key: 'L', openWith: '[', closeWith: ']([![Url:!:http://]!] "[![Title]!]")', placeHolder: 'Your text to link here...', className: "markItUpButton-insert-link" }
                    ]
                }
            };
            $.each(Cobalt.Markup.customBBcodeButtons, function (i, val) {
                Cobalt.Markup.markItUpSets.standardbbcode.markupSet.push(val);
            });
            Cobalt.runOnHtmlInsert(Cobalt.Markup.addTabSupport);
            Cobalt.runOnHtmlInsert(Cobalt.Markup.handleShowMarkupTypeSelection);
            Cobalt.runOnHtmlInsert(Cobalt.Markup.loadCustomButtonActions);

        },
        editors: [],
        addTabSupport: function ($parent) {
            $parent.find('.j-content-editor').each(function () {
                Cobalt.Markup.editors.push(new Cobalt.MarkupEditor($(this)));
            });
        },
        currentSelectedMarkup: function ($parent) {
            return parseInt($parent.find("input.j-markup-type").val(), null);
        },
        handleShowMarkupTypeSelection: function ($parent) {
            $parent.find('.j-content-editor[data-show-markup-selection="false"]').each(function () {
                $(this).find('.j-tab-nav > .b-tab-item').hide();
                $(this).find('.j-markup-type-selector').hide();
            });
        },
        getSelectionHtml: function (button) {
            if (window.getSelection) {
                try {
                    var editor = button.closest("div.markItUp");
                    var ta = editor.find("textarea.j-markup-editor").get(0);
                    return ta.value.substring(ta.selectionStart, ta.selectionEnd);
                } catch (e) {
                    console.log('Cant get selection text ' + e);
                }
            }
            // For IE
            if (document.selection && document.selection.type != "Control") {
                return document.selection.createRange().text;
            }
        },
       getNewLinesForBBCodeList: function (content, numeric) {
            var lines = content.split("\n");
            var result = "";
            numeric ? result += "[list]" : result += "[numlist]";
            for (var i = 0; i < lines.length; i++) {
                result += "\n[*]" + lines[i];
            }
            result += "\n";
            numeric ? result += "[/list]" : result += "[/numlist]";
            return result;
        },
        replaceSelectedText: function (editor, html) {
            var markArea = $(editor).parent().parent(".markItUpHeader").siblings('.markItUpEditor').get(0);
            var startStr = markArea.value.substring(0, markArea.selectionStart);
            var endStr = markArea.value.substring(markArea.selectionEnd);
            var text = startStr + html + endStr;
            $(editor).parent().parent(".markItUpHeader").siblings('.markItUpEditor').val(text);
        },
        loadCustomButtonActions: function () {
            $(".markItUpButton-list-bullet").unbind('click');
            $(".markItUpButton-list-numeric").unbind('click');
            $(".markItUpButton-list-bullet").bind("click", function (e) {
                e.preventDefault();
                var content = Cobalt.Markup.getSelectionHtml($(this));
                Cobalt.Markup.replaceSelectedText(this, Cobalt.Markup.getNewLinesForBBCodeList(content, true));
            });
            $(".markItUpButton-list-numeric").bind("click", function (e) {
                e.preventDefault();
                var content = Cobalt.Markup.getSelectionHtml($(this));
                Cobalt.Markup.replaceSelectedText(this, Cobalt.Markup.getNewLinesForBBCodeList(content, false));
            });
        }
    };
})(jQuery, Cobalt);


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.Markup.js